/* eslint-disable import/prefer-default-export */

export const setDelay = (callback) => {
  setTimeout(() => {
    callback();
  }, 800);
};
